import { Component, OnInit } from '@angular/core';
import { Inventariolote } from 'src/app/models/inventariolote';
import { LoteService } from 'src/app/services/lote.service';
import { Lote } from 'src/app/models/lote';

@Component({
  selector: 'app-inventariolotes',
  templateUrl: './inventariolotes.component.html',
  styleUrls: ['./inventariolotes.component.css']
})
export class InventariolotesComponent implements OnInit {
  inventariolote : Inventariolote[] = []; 

  

  constructor(
    private loteService: LoteService
  ) { }

  ngOnInit() {
    this.despliegalotes();
  }


  despliegalotes( ) {
    this.loteService.muestrainventario().subscribe(resp => {
      this.inventariolote = resp.loteactualizado;
      console.log( "----------aqui222", this.inventariolote);

    })

    
  }






  registrarlote( loteseleccion : Inventariolote){
    console.log (loteseleccion);
    
    this.loteService.actualizalotedisponible( loteseleccion )
    .subscribe(resp=>{
      console.log (resp);
    })

  //   const lote = new Lote(
  //   this.idempresa,
  //   this.idprecompra,
  //   this.miFormulario.get("numerolote").value,
  //   this.miFormulario.get("descripcionlote").value,
  //   this.miFormulario.get("cantidad").value,
  //   null,
  //   false

  //     );

    

  //  this.loteService.crearlote(lote) 
  //     .subscribe ( resp => {
  //       this.miFormulario.reset();
     
  //       this.listadolote = resp.lote;

  //     });
  //  }

}
}
